<template>
  <div class="article-detail-container">
    <w-nav-bar :nav_title="communityData.topic && communityData.topic.name || '详情'" @mobileLeftBtn="pageBack"
               :icon="isWxMini && needShare ? '' : 'iconchevron-left '">
      <div slot="rightContent" @click="shareArticle" v-if="!notData">
        <span class="iconfont iconfenxiang1" style="font-size: 24px"></span>
      </div>
    </w-nav-bar>
    <div class="to_app" v-if="!isWxMini && !isAlipayClient && !isUCClient && !isQuaReClient" @click="openApp">
      <img src="https://files.wondercv.com/m/bbs/to_app/to_app_wondercv_logo.png" alt="">
      <div class="open">下载</div>
    </div>
    <w-no-result v-if="notData" text="该讨论帖不存在"></w-no-result>
    <template v-else>
      <div class="scroll_container">
        <cube-scroll :data="[rootComments]" :options="options" :scroll-events="['scroll']"
                     ref="articleComment">
          <community-item :community-data="communityData" @showBigImg="showBigImg" data-type="detail"
                          @handleComment="handleClick"/>
          <div class="comment-container">
            <div class="comment-list flex-column" v-if="allCommentCount > 0">
              <span class="comment-title" style="padding-top: 10px;font-weight: 600">共 {{ allCommentCount }} 条评论</span>
              <div class="comment-content">
                <template v-for="(item, index) in rootComments">
                  <div class="comment-item flex-column" :key="index" v-if="!(!isFirstCommentShow && index < 10 && index >= 5 )">
                    <div class="comment-user-info flex-between">
                      <div class="info" v-if="item.user">
                        <img class="avatar" :src="item.user.avatar_url" alt="">
                        <div class="user-info-box">
                          <div class="flex-start">
                            <span>{{ item.user.username || '超级简历用户' }}{{isAuthor(communityData.user,item.user)?'(作者)':''}}</span>
                            <img src="https://files.wondercv.com/rn/bbs/commentTop.png" alt="" class="comment-top"
                                 v-show="item.priority === 2||item.priority === 3">
                            <official :is_rb="item.user.is_rb" :adminId="item.admin_id" style="margin-left: 10px"/>
                          </div>
                          <div class="identity" v-if="item.user.community_identity">
                            {{item.user.community_identity}}
                          </div>
                        </div>
                      </div>
                      <div class="approve flex-start" @click.stop="updateLikeStatus(item)" v-show="!item.is_delete">
                        <span>{{ item.like_count | countFilter('like') }}</span>
                        <transition name="like">
                          <span v-if="item.my_status.has_liked" class="iconfont icondianzan1 anim-icon"></span>
                        </transition>
                        <transition name="not">
                          <span v-if="!item.my_status.has_liked " class="iconfont iconweidianzan1 anim-icon"></span>
                        </transition>
                      </div>
                    </div>
                    <div class="comment-item-content">
                      <p class="comment-content-text" :style="{color:item.is_delete?'#9c9c9c':'#404040'}"
                         @touchstart.prevent="onTouchStart(item)" @touchmove.prevent="onTouchMove"
                         @touchend.prevent="onTouchEnd(item)">
                        {{ item.is_delete ? '该评论已删除' : item.content }}
                      </p>
                      <div class="comment-content-bottom">
                        <span class="comment-time">{{ item.publish_at | articleTimeFormatFilter }}</span>
                        <span> · </span>
                        <span class="comment-reply" @click.stop="handleClick('reply', item,'root')"
                              v-show="!item.is_delete">回复</span>
                      </div>
                      <template v-if="item.reply_comments">
                        <div class="comment-root-detail" style="background-color: #f9f9f9" v-if="item.reply_comments.reply_comment_count"
                             @click="viewAllComment(item)">
                          <template v-for="(val, index) in item.reply_comments.comments">
                            <p class="comment-other" v-if="val.user" :key="index">
                              <span class="reply-user-name">{{ val.user.username || '超级简历用户' }}：</span>
                              <span>{{ val.is_delete ? '该评论已删除' : val.content }}</span>
                            </p>
                          </template>
                          <span class="more-replay" v-if="item.reply_comments.reply_comment_count > 2"
                                @click.stop="viewAllComment(item)">查看全部 {{item.reply_comments.reply_comment_count}} 条回复</span>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
              <div v-show="rootComments.length > 5 && rootCommentTotal != rootComments.length" class="showMoreBtn" @click.stop="handleClickShowMore">查看更多评论<i class="iconfont iconchevron-down"></i></div>
            </div>
            <div class="comment-empty" v-else>
              <div class="img-container flex-center">
                <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
              </div>
              <span class="comment-title">暂无评论</span>
            </div>
            <div class="guess-like-box" v-if="likeRecommendList.length">
              <p class="title">猜你喜欢</p>
              <div class="guess-like-box-item" v-for="(item, index) in likeRecommendList" :key="index + item.id" @click="toOtherDetail(item)">
                <div class="comment-user-info flex-between">
                  <div class="info">
                    <img class="avatar" :src="item.user.avatar_url || 'https://files.wondercv.com/activity/lottery/avatar-1.png'"  alt="">
                    <div class="user-info-box">
                      <div class="flex-start">
                        <span>{{item.user && item.user.username || "超级简历用户"}}</span>
                        <official style="margin-left: 10px"/>
                      </div>
                      <div class="identity">
                        {{item.user.community_identity && item.user.community_identity || ''}}
                      </div>
                    </div>
                  </div>
                  <div class="approve flex-start" @click.stop="onClickLike(item, index)">
                    <span>{{ item.like_count | countFilter('like') }}</span>
                    <transition name="like" v-if="item.my_status.has_liked">
                      <span class="iconfont icondianzan1 anim-icon"></span>
                    </transition>
                    <transition name="not" v-else>
                      <span class="iconfont iconweidianzan1 anim-icon"></span>
                    </transition>
                  </div>
                </div>
                <div class="content-main">
                  <p class="vote-text-title" v-if="item.vote || item.title">
                    <span class="tag" v-if="item.vote">【投票】</span>
                    <span>{{item.vote ? item.vote.name : item.title}}</span>
                  </p>
                  <div class="item-content">
                    {{item.content}}
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 100%;height:50px;">
            </div>
          </div>
        </cube-scroll>
      </div>
      <div class="footer flex-start article-detail-footer flex-between" v-show="!commentShow">
        <div class="open_app" @click="openApp" v-if="!isWxMini && !isAlipayClient && !isUCClient && !isQuaReClient">
          App 内打开
<!--          <wechat-open-app :extinfoStr="appParam" v-if="isWechatBrowser"></wechat-open-app>-->
        </div>
        <button type="text" @click="handleClick('create', communityData)"><span class="iconfont iconbianji"
                                                                                style="font-size: 14px;margin-right: 6px"/><span>我来说几句...</span>
        </button>
        <div class="icon-wrapper flex-start" v-if="communityData.my_status">
          <div class="icon-container" @click="handleCommentScroll">
            <span class="iconfont iconpinglun1"></span>
            <span class="comment-total total-count">评论 {{ communityData.comment_count>0?(communityData.comment_count>999?999:communityData.comment_count):''  }}</span>
          </div>
          <div class="icon-container" @click="likeArticle" v-if="communityData.topic.id!=81">
            <transition name="like">
              <span v-if="communityData.my_status.has_liked&&communityData.topic.id!=81"
                    class="iconfont icondianzan1 anim-icon"></span>
            </transition>
            <transition name="not">
              <span v-if="!communityData.my_status.has_liked&&communityData.topic.id!=81"
                    class="iconfont iconweidianzan1 anim-icon"></span>
            </transition>
            <span class="approve-total total-count">喜欢 {{ communityData.like_count>0?(communityData.like_count>999?999:communityData.like_count):''  }}</span>
          </div>
          <div v-else class="icon-container" @click="likeArticle">
            <AnimationExp type="detail" :num="communityData.like_count" :has_like="communityData.my_status.has_liked"/>
          </div>
          <div class="icon-container" @click="collectArticle">
            <span class="iconfont"
                  :class="communityData.my_status.has_collected ? 'iconyishoucang1' : 'iconweishoucang'"></span>
            <span class="approve-total total-count">{{communityData.my_status.has_collected ?'已收藏':'收藏'}}</span>
          </div>
        </div>
      </div>
    </template>
    <div class="big_img_container">
      <big-img-popup :state="bigImgState">
        <big-img slot="content" :state="bigImgState" :imgIndex="imgIndex" :imgList="communityData.images"
                 :isDel='false' @closeBigImg="bigImgState=false"></big-img>
      </big-img-popup>
    </div>
    <comment-dialog ref="commentDialog" :state="commentShow" :operation-comment="operationComment"
                    @handleClose="changeCommentState" @sendComment="sendComment" :author="communityData.user"/>
    <!--    commentData.id  以及评论ID-->
    <comment-detail :comment-detail-show="commentDetailShow" :comment-data="commentData" :author="communityData.user"
                    @updateLikeStatus="updateLikeStatus" @handleClose="changeCommentDetailState"
                    @handleComment="handleClick" @onPullingUp="onPullingUp"
                    @commentActionSheet="changeUserComment"></comment-detail>
    <action-sheet-community :action-sheet-state="actionSheetState" :operation="actionSheetOperation"
                            :action-sheet-data="operationComment" @selectItem="selectItem"
                            @handleClose="changeActionSheetState"/>
    <w-share-wx :state="shareWxState" @handleClose="shareWxState = false"></w-share-wx>
    <w-user-dialog/>
  </div>
</template>

<script>
  import communityItem from '../components/community-item'
  import WNavBar from '../../../components/global/w-navbar'
  import commentDialog from '../components/comment-dialog'
  import commentDetail from '../components/comment-detail'
  import actionSheetCommunity from '../components/action-sheet-community'
  import WShareWx from '../../../components/global/w-share-wx'
  import WNoResult from '../../../components/global/w-no-result'
  import BigImgPopup from '../components/big-img-popup'
  import BigImg from '../components/big-img'
  import {communityMixin} from '../../../assets/js/mixin/community'
  import {envMixin, loginMixin, windowEventMixin, } from '../../../assets/js/mixin/global'
  import {userMixin} from "../../../assets/js/mixin/user";
  import {componentsMixin} from '../../../assets/js/mixin/components'
  import AnimationExp from "../components/animationExp"
  import Cookies from 'js-cookie'
  import official from "../components/official";
  import WechatOpenApp from '../../../components/wechat-open-app/wechat-open-app'
  import WUserDialog from "../../../components/global/w-user-dialog.vue"
  import {mapActions} from "vuex"
  export default {
    name: 'article-detail',
    mixins: [communityMixin, envMixin, componentsMixin, loginMixin, windowEventMixin,userMixin],
    data() {
      return {
        communityData: {},
        rootComments: [],
        rootCommentTotal: -1,
        allCommentCount: -1,
        commentShow: false,
        commentText: '',
        commentDetailShow: false,
        commentId: null, // 当前查看全部评论的id
        commentPage: 1, // 当前查看全部评论的当前页数
        commentTotal: 0, // 当前全部评论的数量
        commentList: [], // 当前全部评论的数组
        commentData: {}, // 评论的数据
        operationComment: {
          commentType: 'create'
        },
        actionSheetState: false,
        actionSheetOperation: [],
        shareWxState: false,
        notData: false,
        timer: null,
        options: {
          pullUpLoad: true
        }, // scroll 事件配置
        rootCommentPage: {
          page: 1,
          size: 10
        },
        bigImgState: false,
        imgIndex: 0,
        ing: false,
        mobile: null,
        appParam: {
          type: 'bbs',
          id: this.$route.params.token
        },
        isFirstCommentShow: false,
        likeRecommendList: [],//猜你喜欢推荐
        isLoadingComment: false
      }
    },
    async mounted() {
      this.changeNeedShareValue()
      await this.loginByWx()
      this.getAccountUser()
      this.getArticleDetail()
      this.getArticleComments()
      let md = new MobileDetect(navigator.userAgent);
      this.mobile = md.os();
    },
    beforeRouteUpdate(to, from, next) {
      this.notData = false
      this.getArticleDetail(to.params.token)
      this.getArticleComments(to.params.token)
      window.scrollTo(0, 0)
      next()
    },
    computed: {},
    watch: {},
    components: {
      communityItem,
      WNavBar,
      commentDialog,
      commentDetail,
      actionSheetCommunity,
      WShareWx,
      WNoResult,
      BigImg,
      BigImgPopup,
      AnimationExp,
      official,
      WechatOpenApp,
      WUserDialog
    },
    methods: {
      ...mapActions("user",['getShowUserDialog']),
      // 打开应用宝或者App Store
      toApp() {
        if (this.mobile == 'iOS') {
          window.location.href = 'https://itunes.apple.com/cn/app/%E8%B6%85%E7%BA%A7%E7%AE%80%E5%8E%86-%E5%AE%9E%E4%B9%A0%E6%89%BE%E5%B7%A5%E4%BD%9C%E5%BF%85%E5%A4%87/id1327732591?mt=8'
        } else {
          window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv'
        }
      },
      // 唤醒APP
      openApp() {
        // iOS
        if (this.mobile === 'iOS') {
          // window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
          window.location.href = `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=other&id=${this.$route.params.token}&listType=system&open_type=bbs`;
          // AndroidOS
        } else {

          // 调用安卓协议打开APP  没有安装APP则跳转应用宝
          window.location.href = `android://h5/open?id=${this.$route.params.token}&type=bbs`
          let t = Date.now();

          setTimeout(() => {
            if (Date.now() - t < 1200) {
              window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
            }
          }, 1000);
        }
      },
      // 查看大图
      showBigImg({index}) {
        this.bigImgState = true;
        this.imgIndex = index
      },
      // 开始长按
      onTouchStart(item) {
        this.timer = setTimeout(() => {
          this.changeUserComment(item)
        }, 500)
        return false
      },
      onTouchMove() {
        clearTimeout(this.timer)
        this.timer = null
      },
      onTouchEnd(item) {
        clearTimeout(this.timer)
        if (this.timer && !item.is_delete) {
          this.handleClick('reply', item, 'root')
        }
        return false
      },
      // 长按执行事件
      changeUserComment(data) {
        this.timer = null
        if (!this.alreadyLogged) {
          this.needLogin()
        } else if (!data.is_delete) {
          this.operationComment = data
          if (data.allow_delete) {
            this.actionSheetOperation = [
              {text: '复制', value: 'copy'},
              {text: '删除', value: 'delete'},
            ]
          } else {
            this.actionSheetOperation = [
              {text: '复制', value: 'copy'},
            ]
          }
          this.changeActionSheetState()
        }
      },
      // action sheet 状态
      changeActionSheetState() {
        this.actionSheetState = !this.actionSheetState
      },
      // 评论发送事件
      async sendComment(content) {
        if (this.ing) return;
        this.ing = true
        try {
          let res = {}, {commentType} = this.operationComment
          if (commentType === 'create') {
            let {id, user} = this.operationComment
            let payload = {
              content,
              to_cv_account_id: user.id,
              platform: this.isEnv
            }
            res = await this.$api.bbs.createComment(id, payload)
          } else if (commentType === 'reply') {
            // console.log(this.operationComment,"====>ope")
            let {news_id, id, user} = this.operationComment
            let payload = {content}
            if (user.id) {
              payload.parent_cv_account_id = user.id
            } else {
              payload.parent_origin_name = user.username
              payload.parent_origin_avatar_url = user.avatar_url
            }
            payload.platform = this.isEnv
            // console.log(this.operationComment,"===>com")
            payload.root_comment_id = this.operationComment.root_comment_id;
            res = await this.$api.bbs.replyComment(news_id, id, payload)
          }
          if (res.code === 1000) {
            this.$createToast({
              txt: '评论成功',
              time: 1000,
              type: 'txt'
            }).show()
            this.changeCommentState()
            if (commentType === 'create') {
              let priorityComments = [],
                restComments = [];
              this.rootComments.forEach(item => {
                if (item.priority === 2 || item.priority === 3) {
                  priorityComments.push(item)
                } else {
                  restComments.push(item)
                }
              })
              this.rootComments = [...priorityComments, res.data, ...restComments]
              // this.rootComments.unshift(res.data)
              // this.rootComments.push(res.data)
              this.rootCommentTotal += 1
              this.allCommentCount += 1
              this.communityData.comment_count += 1
            } else if (commentType === 'reply') {
              let index = this.rootComments.findIndex(item => item.id === this.operationComment.id)
              if (index > -1) {
                // this.rootComments[index].reply_comments.comments.unshift(res.data)
                this.rootComments[index].reply_comments.comments.push(res.data)
                this.rootComments[index].reply_comments.reply_comment_count += 1
                this.allCommentCount += 1
                this.communityData.comment_count += 1
              }
              // 如果是在评论详情中回复则在评论详情中加入当前评论
              if (this.commentData.reply_comments) {
                this.commentData.reply_comments.comments.push(res.data);
              }

            }
            this._synchronizeStateForList(commentType === 'create' ? this.operationComment.id : this.operationComment.news_id, 'comment_count', this.communityData.comment_count)
            this.$refs.commentDialog.commentText = ""
            this.getShowUserDialog(this.cvAccountToken)
          } else {
            this.$createToast({
              txt: res.message,
              time: 1000,
              type: 'warn'
            }).show()
          }
        } catch (e) {
          console.log("error===>", e)
        } finally {
          this.ing = false
        }
      },
      // 查看更多评论弹窗
      changeCommentDetailState() {
        this.commentDetailShow = !this.commentDetailShow
      },
      // input触发focus事件 点击回复
      handleClick(type, data, root) {
        if (!this.alreadyLogged) {
          this.needLogin()
        } else {
          if (root) data.root_comment_id = data.id;
          this.changeCommentState()
          this.operationComment = data
          this.operationComment.commentType = type
          this.$refs.commentDialog && this.$refs.commentDialog.$refs.textArea && this.$refs.commentDialog.$refs.textArea.onFocus()
        }

        //  else if (!this.accountUser.phone_is_bound) {
        //   this.$createDialog({
        //     type: 'confirm',
        //     title: '请绑定手机号',
        //     content: '根据国家相关法律规定，发表内容需绑定手机号',
        //     confirmBtn: {
        //       text: '去绑定',
        //       active: true,
        //       disabled: false,
        //       href: 'javascript:;'
        //     },
        //     cancelBtn: {
        //       text: '我再想想',
        //       active: false,
        //       disabled: false,
        //       href: 'javascript:;'
        //     },
        //     onConfirm: () => {
        //       this.$router.push('/account/alter_phone')
        //     },
        //     onCancel: async () => {
        //
        //     }
        //   }).show()
        // }
      },
      // 改变评论弹窗的状态
      changeCommentState() {
        this.commentShow = !this.commentShow
      },
      // 页面返回事件
      pageBack() {
        if (this.isWxMini && this.needShare) {
          this.$wechat.miniProgram.navigateBack()
        } else if (this.isWxMini) {
          this.$wechat.miniProgram.reLaunch({
            url: `/pages/community-list/community-list?url=${process.env.VUE_APP_HOST}/community`
          })
        } else {
          if (this.$route.query.name == 'community-list') {
            this.$router.replace("/community")
          } else if (this.$route.query.name == 'article-group-detail' && window.history.length > 2) {
            this.$router.back()
          } else {
            this.$router.replace("/community")
          }
        }
      },
      // 评论上拉加载
      onPullingUp() {
        this.commentPage += 1
        this.getAllComment(this.operationComment, false)
      },
      // 上拉加载文章详情页
      onPullingUpArticleComment() {
        if (this.rootCommentTotal > this.rootCommentPage.page * 10) {
          this.rootCommentPage.page += 1;
          this.getArticleComments(null, false)
        }
      },
      // 评论action sheet 操作
      selectItem(data) {
        if (data.value === 'delete') {
          this.$createDialog({
            type: 'confirm',
            title: '提示',
            content: `是否删除当前评论`,
            confirmBtn: {
              active: false,
              text: '取消'
            },
            cancelBtn: {
              active: true,
              text: '删除'
            },
            onCancel: async () => {
              let {token} = this.$route.params
              let res = await this.$api.bbs.deleteComment(token, this.operationComment.id)
              if (res.code === 1000) {
                this.showToast('删除成功', 1500)
                //详情删除
                if (this.commentDetailShow) {
                  let index = -1
                  if (this.commentData.id === this.operationComment.id) {
                    if (this.commentData.reply_comments.comments.length === 0) {
                      this.rootComments.forEach((item, i) => {
                        if (item.id === this.operationComment.id) {
                          index = i
                        }
                      })
                      this.rootComments.splice(index, 1)
                      this.allCommentCount--
                    } else {
                      this.commentData.is_delete = true
                      this.rootComments.forEach((item, i) => {
                        if (item.id === this.operationComment.id) {
                          item.is_delete = true;
                        }
                      })
                    }
                  } else {

                    this.allCommentCount--
                    this.commentData.reply_comments.comments.forEach((item, i) => {
                      if (item.id === this.operationComment.id) {
                        index = i
                      }
                    })
                    this.commentData.reply_comments.comments.splice(index, 1)
                    this.commentData.reply_comments.reply_comment_count--
                    if (this.commentData.reply_comments.comments.length == 0 && this.commentData.is_delete) {
                      this.commentDetailShow = false
                      this.rootComments.forEach((item, i) => {
                        if (item.id == this.commentData.id) {
                          index = i
                        }
                      })
                      this.rootComments.splice(index, 1)
                      this.allCommentCount--
                    }
                    this.rootComments.forEach((item, i) => {
                      if (item.id === this.commentData.id) {
                        item.reply_comments = this.commentData.reply_comments
                      }
                    })
                  }
                  index = -1
                } else {
                  //列表删除
                  let index = -1
                  this.rootComments.forEach((item, i) => {
                    if (item.id === this.operationComment.id) {
                      index = i
                      item.is_delete = true;
                    }
                  })
                  if (index > -1 && this.operationComment.reply_comments.comments.length == 0) {
                    this.rootComments.splice(index, 1)
                    this.allCommentCount--
                  }
                }
              }
            }
          }).show()
        }
      },
      // 点击footer评论icon滚动页面
      handleCommentScroll() {
        let el = document.querySelector('.comment-container')
        this.$refs.articleComment.scrollTo(0, -el.offsetTop)
        // window.scrollTo({ behavior: 'smooth', top: el.offsetTop - 44 })
      },
      // 查看全部评论
      async viewAllComment(item) {
        if (this.commentId !== item.id) {
          this.commentId = item.id
          this.commentList = []
          this.commentPage = 1
          this.commentTotal = -1
          this.operationComment = item
          await this.getAllComment(item, true)
        }
        this.changeCommentDetailState()
      },
      // 查看全部评论接口
      async getAllComment(item, refresh) {
        let {token} = this.$route.params
        let res = await this.$api.bbs.getAllComment(token, item.id, {
          page: this.commentPage,
          size: 10
        })
        if (res.code === 1000) {
          if (refresh) {
            this.commentData = res.data
          } else {
            this.commentData.reply_comments.comments = [...this.commentData.reply_comments.comments, ...res.data.reply_comments.comments]
          }
          // this.commentList = res.data
          // this.commentTotal = res.
        }
      },
      // 评论点赞
      async updateLikeStatus(item) {
        if (!this.alreadyLogged) {
          this.needLogin()
        } else {
          let {token} = this.$route.params
          let res = await this.$api.bbs.updateCommentLike(token, item.id, {
            is_like: !item.my_status.has_liked,
            to_cv_account_id: item.user.id
          })
          if (res.code === 1000) {
            if (item.my_status.has_liked) {
              this.showToast('已取消点赞', 1500);
            } else {
              this.showToast('已点赞', 1500);
            }
            item.my_status.has_liked = !item.my_status.has_liked
            item.my_status.has_liked ? item.like_count += 1 : item.like_count -= 1
          }
        }
      },
      // 获取动态详情
      async getArticleDetail(articleToken) {
        let {token} = this.$route.params
        token = articleToken || token
        let res = await this.$api.bbs.getArticleDetail(token)
        if (res.code === 1000) {
          this.communityData = res.data
          this.getLikeRecommendList()
          let params = {}
          if (this.communityData.topic != null && this.communityData.topic.cover_image != '') {
            params.thumb = this.communityData.topic.cover_image||'https://files.wondercv.com/App%20Icon@2x.png'
            params.imgUrl = this.communityData.topic.cover_image||'https://files.wondercv.com/App%20Icon@2x.png'
            params.img_url = this.communityData.topic.cover_image||'https://files.wondercv.com/App%20Icon@2x.png'
          } else {
            params.imgUrl = 'https://files.wondercv.com/App%20Icon@2x.png'
          }
          setTimeout(async () => {
            await this.$route.meta.shareByWx(this.communityData.content.slice(0, 50), {title: this.communityData.title, ...params})
          }, 1000)

        } else {
          this.communityData = {}
          this.notData = true
        }
      },
      // 获取动态一级评论
      async getArticleComments(articleToken, isFirstPage) {
        try{
          let {token} = this.$route.params
          token = articleToken || token
          let res = await this.$api.bbs.getArticleComment(token, this.rootCommentPage)
          if (res.code === 1000) {
            this.rootComments = isFirstPage ? res.data.root_comments : [...this.rootComments, ...res.data.root_comments]
            this.rootCommentTotal = res.data.root_comment_count
            this.allCommentCount = res.data.all_comment_count
          } else {
            this.rootComments = []
            this.rootCommentTotal = 0
            this.allCommentCount = 0
          }
          this.$refs.articleComment.refresh()
        }finally {
          this.isLoadingComment = false
        }

      },
      handleClickShowMore(){
        if(!this.isFirstCommentShow){
          this.isFirstCommentShow = true
          return
        }
        if(this.isLoadingComment){
          return;
        }
        this.isLoadingComment = true
        this.onPullingUpArticleComment()
      },
      //获取猜你喜欢列表
      async getLikeRecommendList(){
        try {
          let res = await this.$api.bbs.getLikeRecommend({
            topic_id: this.communityData.topic.id || '',
            professions: !!this.communityData.profession_names_dict && this.communityData.profession_names_dict[0] && this.communityData.profession_names_dict[0].value || '',
            custom_tag: this.communityData.custom_tags && this.communityData.custom_tags[0] || '',
            company_name: this.communityData.company && this.communityData.company[0] && this.communityData.company[0].name || '',
            news_id: this.$route.params.token
          })
          if(res.code === 1000){
            this.likeRecommendList = res.data
          }
        }catch (e) {

        }
      },
      //猜你喜欢点赞
      async onClickLike(data, index){
        if (!this.alreadyLogged) {
          this.needLogin()
        } else {
          let {my_status, id, user, topic} = data
          let res = await this.$api.bbs.updateArticleLike(id, {
            is_like: !my_status.has_liked,
            to_cv_account_id: user.id
          })
          if (res.code === 1000) {
            if (my_status.has_liked) {
              this.showToast(topic.id == 81 ? '经验 -1' : '已取消点赞', 1500);
            } else {
              this.showToast(topic.id == 81 ? '经验 +1' : '已点赞', 1500);
            }
            my_status.has_liked = !my_status.has_liked
            my_status.has_liked ? data.like_count += 1 : data.like_count -= 1

          }
        }
      },
      toOtherDetail(item, type){
        let {id, title, content} = item
        let {name} = this.$route
        this.$db.ls.set('shareNeed', true)
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/news-detail/news-detail?url=${process.env.VUE_APP_HOST}/community/article/${id}&title=${title || content}`
          })
        } else {
          this.$router.push(`/community/article/${id}?name=${name}`)
        }
        this.$refs.articleComment.scrollTo(0, 0, 0)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";

  .article-detail-container {
    min-height: $screen-height;
    width: 100vw;
    overflow: hidden;

    .to_app {
      width: 100%;
      height: 50px;
      padding: 0 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #ff6644;

      img {
        width: 86px;
        height: 26px;
      }

      .open {
        width: 58px;
        height: 26px;
        border-radius: 2px;
        background-color: #fff;
        color: #ff6644;
        line-height: 26px;
        text-align: center;
      }
    }

    .mobile-nav {
      .iconfenxiang1 {
        font-size: 20px;
        font-weight: 500;
      }
    }

    @include mobile-container(44px, 50px);

    .scroll_container {
      width: 100vw;
      //height: calc(100vh - 43px);
      height: calc(calc(var(--vh, 1vh) * 100) - 94px);
    }

    .community-item {
      margin-bottom: 0;
      border-bottom: 8px solid #F9F9F9;
    }

    .comment-container {
      //padding: 24px 0;
      background-color: $color-light;
      //text-align: center;
      .comment-list {
        .comment-title {
          color: $color-dark-gray;
          padding-left: 24px;
        }

        .comment-item {
          padding: 24px;
          border-bottom: 1px solid #F9F9F9;

          &:last-child {
            border-bottom: none;
          }

          .comment-user-info {
            margin-bottom: 8px;

            .identity {
              margin-top: 8px;
              font-size: 13px;
              font-weight: 400;
              color: #9C9C9C;
            }

            .info {
              width: 85%;
              display: flex;
              .user-info-box{
                display: flex;
                flex-direction: column;
                justify-content: center;
              }
              .comment-top {
                width: 30px;
                height: 16px;
                margin-left: 8px;
              }

              .avatar {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                margin-right: 8px;
                object-fit: cover;
              }

              span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #404040;
                font-size: $font-size-medium;
                font-weight: 500;
              }
            }

            .approve {
              padding-right: 22px;
              position: relative;
              color: #404040;

              span {
                color: #404040;
                font-size: $font-size-small;
              }

              .iconfont {
                position: absolute;
                font-size: 18px;
                right: 0;
              }

              .icondianzan1 {
                color: $color-theme;
              }
            }
          }

          .comment-item-content {
            .comment-content-text {
              margin-bottom: 16px;
              color: $color-title;
              line-height: 24px;
              font-size: 16px;
              letter-spacing: 0.4px;
              word-break: break-all;
              white-space: pre-line;
            }

            .comment-content-bottom {
              font-size: $font-size-small;
              color: #9c9c9c;
              margin-bottom: 12px;
            }

            .comment-root-detail {
              padding: 14px 16px;
              background-color: #F9F9F9;
              border-radius: 4px;

              .comment-other {
                margin-bottom: 8px;
                line-height: 20px;
                color: #606060;

                &:last-child {
                  margin-bottom: 0;
                }

                .reply-user-name {
                  color: #404040;
                }

                span {
                  word-break: break-all;
                  white-space: pre-line;
                }
              }

              .more-replay {
                color: #4183FF;
              }
            }
          }
        }
      }

      .comment-empty {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .comment-title {
          color: $color-dark-gray;
          //padding-left: 24px;
        }

        .img-container {
          padding: 32px 0 44px;
          width: 100%;

          img {
            width: 64px;
            height: 64px;
          }
        }
      }
    }

    .article-detail-footer {
      //position: relative;
      bottom: 0;
      padding: 0 24px;
      @include ipx-footer(50px, 1px);
      background-color: $color-light;
      border-top: 1px solid #F5F5F7;
      width: 100vw;
      z-index: 99;

      .open_app {
        width: 116px;
        height: 36px;
        border-radius: 18px;
        background-color: #ff6644;
        color: #fff;
        line-height: 36px;
        text-align: center;
        position: absolute;
        top: -47px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
      }

      button {
        height: 32px;
        border-radius: 16px;
        background-color: #f9f9f9;
        color: #bcbcbc;
        border: none;
        width: 161px;
        text-align: left;
        padding-left: 24px;
        margin-right: 10px;
      }

      .icon-wrapper {
        flex: 1;
        height: 100%;


        .icon-container {
          position: relative;
          height: 100%;
          width: calc(100% / 3);

          &:last-child {
            margin-right: 0;
          }

          .iconfont {
            font-size: 22px;
            color: $color-title;
            position: absolute;
            top: 5px;
            left: calc((100% - 22px) / 2);
          }

          .iconyishoucang1 {
            font-size: 24px;
            color: rgb(255, 201, 47);
          }

          .icondianzan1 {
            color: rgb(255, 91, 67);
          }

          .total-count {
            position: absolute;
            font-size: $font-size-small-s;
            color: $color-title;
            bottom: 6px;
            left: 0;
            right: 0;
            text-align: center;
          }
        }
      }
    }

    /deep/ .text-area {
      width: 100%;
      border: none;
      outline: none;
      resize: none;
      padding: 0;

      &::placeholder {
        color: #BCBCBC;
      }
    }
  }

  .anim-icon {
    position: absolute;
  }

  .like-enter, .like-leave-to {
    transform: scale(0);
  }

  .like-enter-active {
    transition: all 0.2s .2s;
  }

  .like-leave-active {
    transition: all .2s;
  }

  .not-enter, .not-leave-to {
    transform: scale(0);
  }

  .not-enter-active {
    transition: all .2s .2s;
  }

  .not-leave-active {
    transition: all .2s;
  }

  .showMoreBtn{
    font-size: 14px;
    font-weight: 400;
    color: #4183FF;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 0px 32px 0px;
    border-bottom: 8px solid #f9f9f9;
  }

  .guess-like-box{
    padding-top: 16px;
    .title{
      padding-left: 24px;
      font-size: 16px;
      font-weight: 600;
      color: #404040;
      line-height: 22px;
      margin-bottom: 4px;
    }
    .guess-like-box-item{
      padding: 20px 24px;
      border-bottom: 8px solid #f9f9f9;
      .comment-user-info {
        margin-bottom: 10px;
        align-items: flex-start;
        .identity {
          margin-top: 8px;
          font-size: 13px;
          font-weight: 400;
          color: #9C9C9C;
        }
        .info {
          width: 85%;
          display: flex;
          .user-info-box{
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .comment-top {
            width: 30px;
            height: 16px;
            margin-left: 8px;
          }

          .avatar {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin-right: 8px;
            object-fit: cover;
          }

          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #404040;
            font-size: $font-size-medium;
            font-weight: 500;
          }
        }
        .approve {
          padding-right: 22px;
          position: relative;
          color: #404040;

          span {
            color: #404040;
            font-size: $font-size-small;
          }

          .iconfont {
            position: absolute;
            font-size: 18px;
            right: 0;
          }

          .icondianzan1 {
            color: $color-theme;
          }
        }
      }
      .content-main{
        width: 100%;
        .vote-text-title{
          width: 100%;
          font-size: 16px;
          font-weight: 600 !important;
          color: #404040;
          line-height: 22px;
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //溢出用省略号显示
          white-space:nowrap;
          margin-bottom: 8px;
          span{
            font-weight: 600;
          }
          .tag{
            color: #f64;
          }

        }
        .item-content{
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          color: #404040;
          line-height: 24px;
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //溢出用省略号显示
          display:-webkit-box; //将对象作为弹性伸缩盒子模型显示。
          -webkit-box-orient:vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
          -webkit-line-clamp: 3;
        }
      }
    }
  }

</style>
